'use strict';

const FacebookPromNight = {
  init(payload, done) {
    document.querySelectorAll('.share-links .icon-facebook').forEach(el =>
      el.addEventListener('click', e => {
        e.preventDefault();
        return window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            el.getAttribute('href')
          )}`,
          '_blank',
          'width=626,height=436'
        );
      })
    );

    return done();
  },
};

module.exports = FacebookPromNight;
